import Layout from '@/layout';
var commodityShopRouter = {
  path: '/commodity-shop',
  component: Layout,
  redirect: '/commodity-shop/merchants-in',
  name: 'commodity-shop',
  alwaysShow: true,
  meta: {
    title: '商品及店铺管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'merchants-in',
    component: function component(resolve) {
      return require(['@/views/my-create/store-management/merchants-in/index.vue'], resolve);
    },
    name: 'merchants-in',
    meta: {
      title: '店铺入驻',
      icon: ''
    }
  }, {
    path: 'merchant-classification',
    component: function component() {
      return import('@/views/my-create/store-management/merchant-classification/index');
    },
    name: 'merchant-classification',
    meta: {
      title: '商户分类',
      icon: ''
    }
  }, {
    path: 'sales-statistics',
    component: function component(resolve) {
      return require(['@/views/my-create/store-management/sales-statistics/index.vue'], resolve);
    },
    name: 'sales-statistics',
    meta: {
      title: '销售情况统计',
      icon: ''
    }
  }, {
    path: 'commodity-management',
    component: function component(resolve) {
      return require(['@/views/my-create/store-management/commodity-management/index.vue'], resolve);
    },
    name: 'commodity-management',
    meta: {
      title: '商品管理',
      icon: ''
    }
  }, {
    path: 'store-management',
    component: function component(resolve) {
      return require(['@/views/my-create/store-management/store-management/index.vue'], resolve);
    },
    name: 'store-management',
    meta: {
      title: '店铺管理',
      icon: ''
    }
  }, {
    path: 'store-type',
    component: function component(resolve) {
      return require(['@/views/my-create/store-management/store-type/index.vue'], resolve);
    },
    name: 'store-type',
    meta: {
      title: '店铺类型',
      icon: ''
    }
  }, {
    path: 'store-application',
    component: function component(resolve) {
      return require(['@/views/my-create/store-management/store-application/index.vue'], resolve);
    },
    name: 'store-application',
    meta: {
      title: '店铺入驻申请',
      icon: ''
    }
  }, {
    path: 'store-list',
    component: function component(resolve) {
      return require(['@/views/my-create/store-management/store-list/index.vue'], resolve);
    },
    name: 'store-list',
    meta: {
      title: '店铺列表',
      icon: ''
    }
  }]
};
export default commodityShopRouter;